import { H1 } from '#app/components/typography/h1.tsx'
import { P } from '#app/components/typography/p.tsx'

export default function NavigationRoute() {
	return (
		<>
			<H1>Navigation</H1>
			<P className="mt-6 max-w-2xl">Components that pertain to navigation, i.e. moving between pages within (and outside) your app.</P>
		</>
	)
}
